<template>
	<div class="flex-box">
		<div class="search-box">
			<div v-if="$hasPermission('A20401')">
				<label style="width: auto;" class="searchItemName">渠道：</label>
				<el-select v-model="SelectChannelId" placeholder="必选" v-on:change="channelIdSelectChange">
					<el-option v-for="item in options" :key="item.id" :label="item.channelName" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<div v-if="$hasPermission('A20401') && options2.length!=0">
				<label class="searchItemName">子渠道：</label>
				<el-select v-model="SelectChannelChildId" placeholder="子渠道" v-if="options2.length!=0" clearable>
					<el-option v-for="item in options2" :key="item.id" :label="item.channelChildName" :value="item.id"></el-option>
				</el-select>
			</div>
			
			 
			<div>
				<label class="searchItemName">筛选日期：</label>
				<el-date-picker v-model="dateRange" type="daterange" align="right" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
				</el-date-picker>
			</div>
			<el-button style="margin-left: 10px;" type="primary" v-on:click="GetData()" icon="el-icon-search">查询</el-button>
			<el-button style="margin-left: 10px;" type="primary" v-on:click="ExportTable()"
				icon="el-icon-download">下载统计数据信息</el-button>
		</div>
		<!-- 设备总金额(实收)柱状图 -->
		<div class="detail-chart-wrap" v-show="tableData.length > 0">
			<div ref="deviceAmountChart" class="detail-chart"></div>
		</div>
		<!--数据表格-->
		<div>
			<el-table
				:data="tableDataDisplay"
				border
				style="width: 100%;margin: 15px 0px;">
				<el-table-column prop="deviceCode" label="设备编号" width="auto" min-width="110" align="center">
				</el-table-column>
				<el-table-column prop="address" label="投放地址" width="auto" min-width="160" align="center">
				</el-table-column>
				<el-table-column prop="examineCount" label="体检次数" width="auto" min-width="110" align="center">
				</el-table-column>
				<el-table-column prop="photoCount" label="拍照次数" width="auto" min-width="110" align="center">
				</el-table-column>
				<el-table-column prop="examinePhotoCount" label="体检+拍照次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="credentPhotoCount" label="证件照次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="healthPhotoCount" label="健康证相片次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="driverExamFormCount" label="驾驶人体检表次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="healthApplyFormCount" label="健康证申请表次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="practitionerListCount" label="从业名单次数" width="auto" min-width="110" align="center">
				</el-table-column>
				<el-table-column prop="examineActualCount" label="体检次数(实收)" width="auto" min-width="130" align="center">
				</el-table-column>
				<el-table-column prop="photoActualCount" label="拍照次数(实收)" width="auto" min-width="130" align="center">
				</el-table-column>
				<el-table-column v-if="$hasPermission('A20402')" prop="examineAmountTotal" label="体检总金额" width="auto" min-width="120" align="center">
					<template slot-scope="scope">
						{{ (Number(scope.row.examineAmountTotal || 0) / 100).toFixed(2) }}元
					</template>
				</el-table-column>
				<el-table-column v-if="$hasPermission('A20402')" prop="photoAmountTotal" label="拍照总金额" width="auto" min-width="120" align="center">
					<template slot-scope="scope">
						{{ (Number(scope.row.photoAmountTotal || 0) / 100).toFixed(2) }}元
					</template>
				</el-table-column>
				<el-table-column v-if="$hasPermission('A20402')" prop="examinePhotoAmountTotal" label="体检+拍照总金额" width="auto" min-width="140" align="center">
					<template slot-scope="scope">
						{{ (Number(scope.row.examinePhotoAmountTotal || 0) / 100).toFixed(2) }}元
					</template>
				</el-table-column>
				<el-table-column v-if="$hasPermission('A20402')" prop="credentPhotoAmountTotal" label="证件照总金额" width="auto" min-width="120" align="center">
					<template slot-scope="scope">
						{{ (Number(scope.row.credentPhotoAmountTotal || 0) / 100).toFixed(2) }}元
					</template>
				</el-table-column>
				<el-table-column v-if="$hasPermission('A20402')" prop="healthPhotoAmountTotal" label="健康证相片总金额" width="auto" min-width="140" align="center">
					<template slot-scope="scope">
						{{ (Number(scope.row.healthPhotoAmountTotal || 0) / 100).toFixed(2) }}元
					</template>
				</el-table-column>
				<el-table-column v-if="$hasPermission('A20402')" prop="driverExamFormAmountTotal" label="体检表总金额" width="auto" min-width="120" align="center">
					<template slot-scope="scope">
						{{ (Number(scope.row.driverExamFormAmountTotal || 0) / 100).toFixed(2) }}元
					</template>
				</el-table-column>
				<el-table-column v-if="$hasPermission('A20402')" prop="healthApplyFormAmountTotal" label="申请表总金额" width="auto" min-width="120" align="center">
					<template slot-scope="scope">
						{{ (Number(scope.row.healthApplyFormAmountTotal || 0) / 100).toFixed(2) }}元
					</template>
				</el-table-column>
				<el-table-column v-if="$hasPermission('A20402')" prop="practitionerListAmountTotal" label="从业名单总金额" width="auto" min-width="130" align="center">
					<template slot-scope="scope">
						{{ (Number(scope.row.practitionerListAmountTotal || 0) / 100).toFixed(2) }}元
					</template>
				</el-table-column>
				<el-table-column v-if="$hasPermission('A20402')" prop="actualAmount" label="总金额(实收)" width="auto" min-width="130" align="center">
					<template slot-scope="scope">
						{{ (Number(scope.row.actualAmount || 0) / 100).toFixed(2) }}元
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- <div>
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
				:page-size="queryParams.pageSize" layout="sizes, prev, pager, next" :total="total">
			</el-pagination>
		</div> -->
	</div>
</template>

<script>
	import Excel from '../../../../public/tools/exportExcelHelp.js';
	import {
		post
	} from '../../../../public/request/request.js';
	import * as echarts from 'echarts';

	export default {
		data() {
			return {
				chartInstance: null,
				/**
				 * 数据总条数
				 */
				total: 0,
				/**
				 * 接口查询参数
				 */
				queryParams: {
					/**
					 * 当前页码
					 */
					pageIndex: 1,
					/**
					 * 每页条数
					 */
					pageSize: 10,
					/**
					 * 渠道
					 */
					channelId: 0,
					/**
					 * 子渠道
					 */
					channelChildId : 0,
					/**
					 * 开始日期
					 */
					beginTime: '',
					/**
					 * 结束日期
					 */
					endTime: '',
				},
				/**
				 * 渠道下拉框
				 */
				options: [],
				/**
				 * 子渠道
				 */
				options2:[],
				/**
				 * 数据表格
				 */
				tableData: [],
				/**
				 * 新增数据model
				 */
				form: {},
				/**
				 * el-dialog 参数
				 */
				dialogFormVisible: false,
				dialogTitle: '',
				dialogOperationType: '',
				/**
				 * 日期框快捷选项
				 */
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
			}
		},
		/**
		 * 方法
		 */
		methods: {
			/**
			 * 计算合计数据
			 */
			calculateTotals() {
				const totals = {
					examineCount: 0,
					photoCount: 0,
					examinePhotoCount: 0,
					credentPhotoCount: 0,
					healthPhotoCount: 0,
					driverExamFormCount: 0,
					healthApplyFormCount: 0,
					practitionerListCount: 0,
					examineActualCount: 0,
					photoActualCount: 0,
					examineAmountTotal: 0,
					photoAmountTotal: 0,
					examinePhotoAmountTotal: 0,
					credentPhotoAmountTotal: 0,
					healthPhotoAmountTotal: 0,
					driverExamFormAmountTotal: 0,
					healthApplyFormAmountTotal: 0,
					practitionerListAmountTotal: 0,
					actualAmount: 0
				};
				this.tableData.forEach(item => {
					totals.examineCount += Number(item.examineCount || 0);
					totals.photoCount += Number(item.photoCount || 0);
					totals.examinePhotoCount += Number(item.examinePhotoCount || 0);
					totals.credentPhotoCount += Number(item.credentPhotoCount || 0);
					totals.healthPhotoCount += Number(item.healthPhotoCount || 0);
					totals.driverExamFormCount += Number(item.driverExamFormCount || 0);
					totals.healthApplyFormCount += Number(item.healthApplyFormCount || 0);
					totals.practitionerListCount += Number(item.practitionerListCount || 0);
					totals.examineActualCount += Number(item.examineActualCount || 0);
					totals.photoActualCount += Number(item.photoActualCount || 0);
					totals.examineAmountTotal += Number(item.examineAmountTotal || 0);
					totals.photoAmountTotal += Number(item.photoAmountTotal || 0);
					totals.examinePhotoAmountTotal += Number(item.examinePhotoAmountTotal || 0);
					totals.credentPhotoAmountTotal += Number(item.credentPhotoAmountTotal || 0);
					totals.healthPhotoAmountTotal += Number(item.healthPhotoAmountTotal || 0);
					totals.driverExamFormAmountTotal += Number(item.driverExamFormAmountTotal || 0);
					totals.healthApplyFormAmountTotal += Number(item.healthApplyFormAmountTotal || 0);
					totals.practitionerListAmountTotal += Number(item.practitionerListAmountTotal || 0);
					totals.actualAmount += Number(item.actualAmount || 0);
				});
				return totals;
			},
			/**
			 * 获取数据列表
			 */
			GetData() {
				const loading = this.openLoading();
				// 获取每日统计
				post('604', this.queryParams)
					.then(response => {
						if (response.data.result == 0) {
							this.tableData = response.data.data;
							this.$nextTick(() => this.updateDeviceAmountChart());
							//this.total = response.data.data.pageCount * this.queryParams.pageSize;
							loading.close();
						} else {
							this.$message.error('查询数据失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '查询数据失败');
					});
			},
			/**
			 * 导出记录表
			 */
			ExportTable(){
				const totals = this.calculateTotals();
				const hasAmountPermission = this.$hasPermission('A20402');
				const data = this.tableData.map(item => {
					const row = {
						'设备编号': item.deviceCode,
						'投放地址': item.address,
						'体检次数': Number(item.examineCount || 0),
						'拍照次数': Number(item.photoCount || 0),
						'体检+拍照次数': Number(item.examinePhotoCount || 0),
						'证件照次数': Number(item.credentPhotoCount || 0),
						'健康证相片次数': Number(item.healthPhotoCount || 0),
						'驾驶人体检表次数': Number(item.driverExamFormCount || 0),
						'健康证申请表次数': Number(item.healthApplyFormCount || 0),
						'从业名单次数': Number(item.practitionerListCount || 0),
						'体检次数(实收)': Number(item.examineActualCount || 0),
						'拍照次数(实收)': Number(item.photoActualCount || 0)
					};
					if (hasAmountPermission) {
						row['体检总金额'] = Number(item.examineAmountTotal || 0) / 100;
						row['拍照总金额'] = Number(item.photoAmountTotal || 0) / 100;
						row['体检+拍照总金额'] = Number(item.examinePhotoAmountTotal || 0) / 100;
						row['证件照总金额'] = Number(item.credentPhotoAmountTotal || 0) / 100;
						row['健康证相片总金额'] = Number(item.healthPhotoAmountTotal || 0) / 100;
						row['体检表总金额'] = Number(item.driverExamFormAmountTotal || 0) / 100;
						row['申请表总金额'] = Number(item.healthApplyFormAmountTotal || 0) / 100;
						row['从业名单总金额'] = Number(item.practitionerListAmountTotal || 0) / 100;
						row['总金额(实收)'] = Number(item.actualAmount || 0) / 100;
					}
					return row;
				});
				const totalRow = {
					'设备编号': '合计',
					'投放地址': '',
					'体检次数': totals.examineCount,
					'拍照次数': totals.photoCount,
					'体检+拍照次数': totals.examinePhotoCount,
					'证件照次数': totals.credentPhotoCount,
					'健康证相片次数': totals.healthPhotoCount,
					'驾驶人体检表次数': totals.driverExamFormCount,
					'健康证申请表次数': totals.healthApplyFormCount,
					'从业名单次数': totals.practitionerListCount,
					'体检次数(实收)': totals.examineActualCount,
					'拍照次数(实收)': totals.photoActualCount
				};
				if (hasAmountPermission) {
					totalRow['体检总金额'] = (totals.examineAmountTotal / 100).toFixed(2);
					totalRow['拍照总金额'] = (totals.photoAmountTotal / 100).toFixed(2);
					totalRow['体检+拍照总金额'] = (totals.examinePhotoAmountTotal / 100).toFixed(2);
					totalRow['证件照总金额'] = (totals.credentPhotoAmountTotal / 100).toFixed(2);
					totalRow['健康证相片总金额'] = (totals.healthPhotoAmountTotal / 100).toFixed(2);
					totalRow['体检表总金额'] = (totals.driverExamFormAmountTotal / 100).toFixed(2);
					totalRow['申请表总金额'] = (totals.healthApplyFormAmountTotal / 100).toFixed(2);
					totalRow['从业名单总金额'] = (totals.practitionerListAmountTotal / 100).toFixed(2);
					totalRow['总金额(实收)'] = (totals.actualAmount / 100).toFixed(2);
				}
				Excel.ExportExcel([totalRow, ...data]);
			},
			/**
			 * 获取渠道数据
			 */
			GetChannelData() {
				// 检查是否允许获取渠道数据
				const allowChannel = sessionStorage.getItem('allowChannel');
				if (allowChannel === 'false') {
					// 不允许获取渠道，直接调用 GetData
					this.GetData();
					return;
				}
				// 获取渠道数据列表
				post('208', {
						channelName: ''
					})
					.then(response => {
						if (response.data.result == 0) {
							this.options = response.data.data;
							if(this.options.length > 0){
								this.queryParams.channelId = this.options[0].id;
								this.GetChannelData2(this.options[0].id);
							}
							this.GetData();
						} else {
							this.$message.error('获取渠道失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '获取渠道失败');
					});
			},
			/**
			 * 获取子渠道数据
			 */
			GetChannelData2(channelId) {
				// 获取子渠道数据列表
				post('209', {objId: channelId})
					.then(response => {
						if (response.data.result == 0) {
							this.options2 = response.data.data;
							if(this.options2.length == 0){
								this.queryParams.channelChildId = 0;
							}
						} else {
							this.$message.error('获取渠道失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '获取渠道失败');
					});
			},
			/**
			 * 页码切换事件
			 */
			handleCurrentChange(pageIndex) {
				this.GetData();
			},
			/**
			 * 每页大小切换事件
			 */
			handleSizeChange(size) {
				this.queryParams.pageSize = size;
			},
			/**
			 * 日期转yyyy-MM-dd
			 * @param {Object} today日期
			 */
			dataToString(today) {
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = today.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			/**
			 * 日期转HH:mm:ss
			 * @param {Object} today日期
			 */
			dataToString2(today) {
				let timeString = today.toLocaleTimeString('it-IT');
				return timeString;
			},
			/**
			 * 打开加载遮罩
			 */
			openLoading() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.4)'
				});
				return loading;
			},
			/**
			 * 根据表格数据更新设备总金额(实收)柱状图
			 */
			updateDeviceAmountChart() {
				const el = this.$refs.deviceAmountChart;
				if (!el) {
					return;
				}
				const rows = [...this.tableData].sort((a, b) =>
					String(a.deviceCode || '').localeCompare(String(b.deviceCode || ''))
				);
				if (!rows.length) {
					if (this.chartInstance) {
						this.chartInstance.dispose();
						this.chartInstance = null;
					}
					return;
				}
				const deviceCodes = rows.map((r) => r.deviceCode || '');
				const yuan = (v) => (Number(v) || 0) / 100;
				const option = {
					color: ['#5470c6'],
					tooltip: {
						trigger: 'axis',
						axisPointer: { type: 'shadow' },
						formatter: (params) => {
							if (!params || !params.length) {
								return '';
							}
							const idx = params[0].dataIndex;
							const row = rows[idx];
							const device = row ? String(row.deviceCode || '') : '';
							const addr = row && row.address != null && row.address !== ''
								? String(row.address)
								: '—';
							const p = params[0];
							const val = p.value != null ? p.value : '';
							return [
								`设备编号：${device}`,
								`投放地址：${addr}`,
								`${p.marker}${p.seriesName}：${val} 元`
							].join('<br/>');
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						top: 32,
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: deviceCodes,
						name: '设备编号',
						axisLabel: { rotate: deviceCodes.length > 10 ? 30 : 0 }
					},
					yAxis: {
						type: 'value',
						name: '金额(元)',
						scale: true
					},
					series: [
						{
							name: '总金额(实收)',
							type: 'bar',
							data: rows.map((r) => yuan(r.actualAmount)),
							barMaxWidth: 48
						}
					]
				};
				if (!this.chartInstance) {
					this.chartInstance = echarts.init(el);
				}
				this.chartInstance.setOption(option, { notMerge: true });
				this.chartInstance.resize();
			},
			_onDeviceChartResize() {
				if (this.chartInstance) {
					this.chartInstance.resize();
				}
			},
			/**
			 * 渠道选择事件, 查询是否有子渠道
			 */
			channelIdSelectChange(){
				if(this.queryParams.channelId != ''){
					this.GetChannelData2(this.queryParams.channelId);
				}else{
					this.options2=[];
					this.queryParams.channelChildId = 0;
				}
			},
		},
		/**
		 * 加载完成事件
		 */
		mounted() {
			window.addEventListener('resize', this._onDeviceChartResize);
			this.GetChannelData();
			this.GetData();
		},
		beforeDestroy() {
			window.removeEventListener('resize', this._onDeviceChartResize);
			if (this.chartInstance) {
				this.chartInstance.dispose();
				this.chartInstance = null;
			}
		},
		/**
		 * 计算属性
		 */
		computed: {
			/**
			 * 表格展示数据（首行合计，不影响图表/接口原始数据）
			 */
			tableDataDisplay() {
				if (!this.tableData || this.tableData.length === 0) {
					return [];
				}
				const t = this.calculateTotals();
				const totalRow = {
					deviceCode: '合计',
					address: '',
					examineCount: t.examineCount,
					photoCount: t.photoCount,
					examinePhotoCount: t.examinePhotoCount,
					credentPhotoCount: t.credentPhotoCount,
					examineActualCount: t.examineActualCount,
					photoActualCount: t.photoActualCount,
					examineAmountTotal: t.examineAmountTotal,
					photoAmountTotal: t.photoAmountTotal,
					examinePhotoAmountTotal: t.examinePhotoAmountTotal,
					credentPhotoAmountTotal: t.credentPhotoAmountTotal,
					actualAmount: t.actualAmount
				};
				return [totalRow, ...this.tableData];
			},
			/**
			 * 日期范围选择框
			 */
			dateRange: {
				get() {
					if (this.queryParams.beginTime == "" || this.queryParams.endTime == "") {
						const today = new Date();
						// 获取上个月的第一天，避免天数不一致的问题
						const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
						this.queryParams.beginTime = this.dataToString(lastMonth);
						this.queryParams.endTime = this.dataToString(today);
					}
					return [new Date(Date.parse(this.queryParams.beginTime)), new Date(Date.parse(this.queryParams
						.endTime))];
				},
				set(value) {
					if (value == null) {
						const today = new Date();
						// 获取上个月的第一天，避免天数不一致的问题
						const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
						this.queryParams.beginTime = this.dataToString(lastMonth);
						this.queryParams.endTime = this.dataToString(today);
					} else {
						this.queryParams.beginTime = this.dataToString(value[0]);
						this.queryParams.endTime = this.dataToString(value[1]);
					}
				}
			},
			/**
			 * 选择的渠道id
			 */
			SelectChannelId: {
				get() {
					if (this.queryParams.channelId == 0) {
						return '';
					} else {
						return this.queryParams.channelId;
					}
				},
				set(value) {
					if (value == '') {
						this.queryParams.channelId = 0;
					} else {
						this.queryParams.channelId = value;
					}
				}
			},
			SelectChannelChildId:{
				get() {
					if (this.queryParams.channelChildId  == 0) {
						return '';
					} else {
						return this.queryParams.channelChildId ;
					}
				},
				set(value) {
					if (value == '') {
						this.queryParams.channelChildId  = 0;
					} else {
						this.queryParams.channelChildId  = value;
					}
				}
			}
		}
	}
</script>

<style>
	.flex-box {
		display: flex;
		flex-direction: column;
	}

	.search-box {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
	}

	.searchItemName {
		width: 100px;
		text-align: right;
		display: inline-block;
	}

	.input-box {
		width: 200px;
	}

	.from-input {
		width: 300px;
	}

	.detail-chart-wrap {
		width: 100%;
		margin: 8px 0 0;
		padding: 12px 16px;
		background: #fff;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		box-sizing: border-box;
	}

	.detail-chart {
		width: 100%;
		height: 360px;
	}
</style>